import { BrandKey } from '@prismamedia/one-brandkey';
import { AutocompleteItem, ChipsInput } from '@prismamedia/one-components';
import {
  ArticleFormat,
  CategoryFormat,
  CategoryStatus,
} from '__generated__/queries-web';
import { FC } from 'react';
import { getFilteredBrandKey } from 'utils/queries/variables';
import { useGetCategories } from './getCategories.web.graphql';
import { spreadCategoryChildren } from './utils';

const MIN_CATEGORY_LEVEL = 3;

interface CategoriesSelectProps {
  value?: AutocompleteItem[];
  onChange?: (value: AutocompleteItem[]) => void;
  className?: string;
  brandKey: BrandKey;
  articleFormat: ArticleFormat;
}

export const CategoriesSelect: FC<CategoriesSelectProps> = ({
  value,
  onChange,
  className,
  brandKey,
  articleFormat,
}) => {
  const getCategories = useGetCategories();

  const isVideo = articleFormat === ArticleFormat.Video;

  const fetchList = (search: string) =>
    getCategories({
      where: {
        title_contains: search || undefined,
        format: isVideo ? CategoryFormat.Channel : CategoryFormat.Category,
        status: CategoryStatus.Published,
        ...getFilteredBrandKey(brandKey),
      },
    }).then(({ categories }) => {
      if (search) {
        return categories
          .filter(({ level }) => level >= MIN_CATEGORY_LEVEL)
          .map(({ id, title }) => ({
            id,
            label: title,
          }));
      }

      return spreadCategoryChildren(
        categories,
        categories.filter(({ level }) => level === MIN_CATEGORY_LEVEL),
      );
    });

  return (
    <ChipsInput
      label={isVideo ? 'Channels' : 'Catégories'}
      value={value}
      className={className}
      onChange={onChange}
      autocomplete={{ fetchList, selectChildren: true }}
    />
  );
};
